// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export const custom = {};
//# sourceMappingURL=inspect.common.js.map